<template>
  <div>
    <ConfirmDialog />
    <Dialog
      :visible.sync="dialogVisible"
      :style="{ width: $isMobile() ? '100vw' : '60vw' }"
      :modal="true"
      header="Criar Intervenção"
    >
      <div v-if="userTask" class="p-col-12">
        <form name="taskForm" class="p-col-12" @submit.prevent="submitForm">
          <div class="p-fluid p-formgrid p-grid">

            <!-- Técnicos -->
            <div class="p-field p-col-12 p-md-12" style="margin-top: 10px">
              <span class="p-float-label">
                <MultiSelect
                  name="usersSelecteds"
                  inputId="usersSelectedsInput"
                  :options="myUsers"
                  :filter="true"
                  :optionLabel="getUserSearchLabel"
                  v-model="userTask.usersSelecteds"
                  v-validate="'required'"
                  display="chip"
                >
                  <template #option="slotProps">
                    {{ slotProps.option.username }}
                  </template>
                </MultiSelect>
                <label for="usersSelectedsInput">Selecionar Funcionário</label>
              </span>
              <small
                v-if="errors.has('usersSelecteds')"
                class="p-error"
                role="alert"
                >Funcionário é obrigatório</small
              >
            </div>

            <!-- Dia -->
            <div class="p-field p-col-12 p-md-4" style="margin-top: 10px">
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon">
                  <i class="pi pi-calendar"></i>
                </span>
                <span class="p-float-label">
                  <v-date-picker
                    name="day"
                    id="day"
                    v-model="userTask.day"
                    v-validate="'required'"
                    :min-date="new Date()"
                    :masks="{ input: 'YYYY-MM-DD' }"
                  >
                    <template v-slot="{ inputValue, inputEvents }">
                      <span class="p-float-label">
                        <input
                          v-bind:class="[
                            { 'p-error': errors.has('day') },
                            'form-control',
                            'p-inputtext',
                            'p-component',
                            'p-filled',
                          ]"
                          :value="inputValue"
                          v-on="inputEvents"
                        />
                        <label for="day">Dia</label>
                      </span>
                    </template>
                  </v-date-picker>
                </span>
                <small v-if="errors.has('day')" class="p-error" role="alert"
                  >Dia é obrigatório</small
                >
              </div>
            </div>

            <!-- Hora início -->
            <div class="p-field p-col-12 p-md-4" style="margin-top: 10px">
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon">
                  <i class="pi pi-clock"></i>
                </span>
                <span class="p-float-label">
                  <Calendar
                    id="start"
                    ref="start"
                    v-model="userTask.start"
                    v-validate="'required|date_format:H:mm'"
                    v-bind:class="[
                      { 'p-error': errors.has('start') },
                      'form-control',
                    ]"
                    :timeOnly="true"
                    :stepMinute="15"
                    name="start"
                    autocomplete="off"
                  />
                  <label for="start">Hora de início</label>
                </span>
              </div>
              <small v-if="errors.has('start')" class="p-error" role="alert"
                >Hora de início é obrigatório</small
              >
            </div>

            <!-- Hora fim -->
            <div class="p-field p-col-12 p-md-4" style="margin-top: 10px">
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon">
                  <i class="pi pi-clock"></i>
                </span>
                <span class="p-float-label">
                  <Calendar
                    id="end"
                    v-model="userTask.end"
                    v-validate="'required|date_format:H:mm|after_start'"
                    v-bind:class="[
                      { 'p-error': errors.has('end') },
                      'form-control',
                    ]"
                    :timeOnly="true"
                    :stepMinute="15"
                    name="end"
                    autocomplete="off"
                  />
                  <label for="end">Hora de fim</label>
                </span>
              </div>
              <small v-if="errors.has('end')" class="p-error" role="alert"
                >Hora de fim tem que ser posterior à de início</small
              >
            </div>

            <!-- PATs -->
            <div class="p-field p-col-12 p-md-12 p-mt-3">
              <AppAutocomplete
                label="Selecionar PATs"
                v-model="userTask.selectedPats"
                :fetchFunction="fetchPats"
                :resolveItemsFunction="fetchPatsByIds"
                :optionLabel="getPatLabel"
                :optionValue="'patNumber'"
                fieldId="supportSelectedPats"
                :multiple="true"
                v-validate.disable="'required'"
                data-vv-name="supportSelectedPats"
              >
                <template #option="slotProps">
                  <div>
                    <b>PAT:</b>
                    {{ slotProps.option.patNumber }} | {{ slotProps.option.typename }}
                    <br />
                    <span
                      style="white-space: normal; word-break: break-word"
                      v-if="slotProps.option.patTitle"
                    >
                      <b>Título:</b> {{ slotProps.option.patTitle }}
                    </span>
                  </div>
                </template>
              </AppAutocomplete>
              <small
                v-if="errors.has('supportSelectedPats')"
                class="p-error"
                role="alert"
                >Selecione pelo menos um PAT</small
              >
            </div>

            <!-- Notas -->
            <div class="p-field p-col-12 p-md-12" style="margin-top: 10px">
              <span class="p-float-label">
                <Textarea
                  id="note"
                  name="note"
                  :autoResize="true"
                  v-model="userTask.note"
                  v-bind:class="[
                    { 'p-error': errors.has('note') },
                    'p-inputtextarea',
                    'p-inputtext',
                    'p-component',
                  ]"
                  rows="5"
                />
                <label for="note">Notas</label>
              </span>
            </div>

            <!-- Confirmado + SMS -->
            <div class="p-col-12 p-grid p-mb-3">
              <div class="p-field p-col-12 p-md-3">
                <div class="p-mb-2">Confirmado:</div>
                <InputSwitch v-model="userTask.marcada" />
              </div>
              <div
                class="p-field p-col-12 p-md-3"
                v-if="can('useSmsNotifications')"
              >
                <div class="p-mb-2">Enviar SMS de confirmação:</div>
                <InputSwitch v-model="notify_sms_confirmation" />
              </div>
            </div>

            <!-- Botões -->
            <div class="p-grid p-jc-center p-col-12">
              <div class="p-col-12 p-md-3 p-mt-2">
                <Button
                  icon="pi pi-check"
                  label="Guardar"
                  class="p-button-success"
                  :disabled="isLoading"
                  @click="submitForm()"
                />
              </div>
              <div class="p-col-12 p-md-3 p-mt-2">
                <Button
                  icon="pi pi-times"
                  label="Cancelar"
                  :disabled="isLoading"
                  @click="cancel()"
                />
              </div>
            </div>

          </div>
        </form>
      </div>
    </Dialog>
  </div>
</template>

<script>
import VeeValidate from "vee-validate";
import AppAutocomplete from "@/components/elements/AppAutocomplete.vue";
import Task from "@/models/task";
import taskService from "@/services/task.service";
import interventionService from "@/services/intervention.service";
import { getOnlyDate, getOnlyTime } from "@/helpers/helpers";

export default {
  name: "CreateInterventionDialog",
  components: { AppAutocomplete },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    preSelectedPats: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      userTask: null,
      interventionTypes: [],
      myUsers: [],
      isLoading: false,
      notify_sms_confirmation: false,
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.notify_sms_confirmation = false;
        this.initTask();
      }
    },
  },
  created() {
    VeeValidate.Validator.extend("after_start", {
      validate: () =>
        new Promise((resolve) => {
          const task = this.userTask;
          if (!task) return resolve({ valid: true });

          let day = task.day instanceof Date ? task.day : new Date(task.day);

          if (!(task.start instanceof Date)) {
            let newStart = new Date();
            newStart.setSeconds(0);
            newStart.setHours(task.start.split(":")[0]);
            newStart.setMinutes(task.start.split(":")[1]);
            task.start = newStart;
          }
          if (!(task.end instanceof Date)) {
            let newEnd = new Date();
            newEnd.setSeconds(0);
            newEnd.setHours(task.end.split(":")[0]);
            newEnd.setMinutes(task.end.split(":")[1]);
            task.end = newEnd;
          }

          task.start.setFullYear(day.getFullYear(), day.getMonth(), day.getDate());
          task.end.setFullYear(day.getFullYear(), day.getMonth(), day.getDate());

          resolve({ valid: task.end > task.start });
        }),
    });
  },
  async mounted() {
    await this.loadData();
  },
  methods: {
    async loadData() {
      try {
        const types = await interventionService.getInterventionTypes();
        if (types) {
          this.interventionTypes = types;
        }
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: "Não foi possível carregar os tipos de intervenção.",
          life: 3000,
        });
      }

      this.loadMyUsers();
    },
    loadMyUsers() {
      const supportUsers = this.$store.state.auth.user.supportUsers;
      if (!supportUsers) return;

      this.myUsers = [];
      for (const [office, users] of Object.entries(supportUsers)) {
        users.forEach((myUser) => {
          this.myUsers.push({
            id: myUser.id,
            username: myUser.username,
            office: office,
            userColor: myUser.userColor,
            officeColor: myUser.officeColor,
            technicianInitials: myUser.technicianInitials,
          });
        });
      }
    },
    initTask() {
      this.userTask = new Task();
      this.userTask.action = "create";
      this.userTask.day = new Date();
      this.userTask.start = null;
      this.userTask.end = null;
      this.userTask.isBooking = false;
      this.userTask.type = null;
      this.userTask.taskType = 0;
      this.userTask.usersSelecteds = [];
      this.userTask.marcada = false;
      this.userTask.task_all_info = {};

      if (this.preSelectedPats && this.preSelectedPats.length > 0) {
        this.userTask.selectedPats = this.preSelectedPats.map(p => p.patNumber);
      }
    },
    submitForm() {
      this.$validator.validateAll().then(async (isValid) => {
        if (!isValid) return;

        const task = this.userTask;
        this.isLoading = true;

        try {
          let day = task.day instanceof Date ? getOnlyDate(task.day) : task.day;
          let start = task.start instanceof Date ? getOnlyTime(task.start) : task.start;
          let end = task.end instanceof Date ? getOnlyTime(task.end) : task.end;

          let taskInfo = {
            type: task.type,
            start: `${day} ${start}`,
            end: `${day} ${end}`,
            resume: task.resume != undefined ? task.resume : "",
            usersSelecteds: task.usersSelecteds,
            note: task.note != undefined ? task.note : "",
            from_support: true,
            marcada: task.marcada,
            notify_sms_confirmation: this.notify_sms_confirmation,
          };

          if (Object.keys(task).includes("proceed_action")) {
            taskInfo["proceed_action"] = true;
          }

          taskInfo.pat_numbers = Array.isArray(task.selectedPats)
            ? task.selectedPats.map((p) =>
                typeof p === "object" ? p.patNumber : p
              )
            : [];

          await this.saveNewTask(taskInfo, task);

          this.dialogVisible = false;
          this.$emit("created");
        } catch (error) {
          if (error && error.toast) {
            if (error.response && error.response.ask_to_proceed) {
              this.$set(task, "proceed_action", true);
              return this.confirmTaskDuplicatedPat(
                error.response.message,
                task,
                error.response.pat_number
              );
            }

            this.$toast.add({
              severity: "error",
              summary: error.toast.summary,
              detail: error.toast.detail,
              life: 4000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Erro Inesperado",
              detail: "Ocorreu um erro que não era esperado. Tente novamente.",
              life: 4000,
            });
          }
        } finally {
          this.isLoading = false;
        }
      });
    },
    async saveNewTask(taskInfo) {
      const patNumbers = Array.from(taskInfo.pat_numbers);

      for (const patNumber of patNumbers) {
        for (const userSelect of taskInfo.usersSelecteds) {
          const newTask = {
            ...taskInfo,
            user_id: userSelect.id,
            pat_number: patNumber,
          };
          delete newTask.pat_numbers;

          const response = await taskService.createTask(newTask);

          if (!response) {
            const error = new Error("Erro ao gravar a tarefa");
            error.toast = {
              summary: "Erro ao gravar",
              detail: "Ocorreu um erro ao gravar a tarefa",
            };
            throw error;
          }

          if (response.status != undefined && response.status == 409) {
            const error = new Error("Erro ao gravar a tarefa");
            error.toast = {
              summary: "Dia fechado",
              detail: `O ${userSelect.username} tem o dia fechado. Tarefa não criada`,
            };
            error.response = response.data;
            throw error;
          }

          this.$toast.add({
            severity: "success",
            summary: "Tarefa criada",
            detail: `Tarefa criada com sucesso para o ${userSelect.username}`,
            life: 3000,
          });
        }
      }
    },
    confirmTaskDuplicatedPat(message, task, patNumber) {
      this.$confirm.require({
        message: message,
        header: `Já existe intervenção para o PAT ${patNumber}, Deseja Continuar?`,
        acceptLabel: "Sim, continuar",
        rejectLabel: "Não, cancelar",
        icon: "pi pi-exclamation-triangle",
        accept: async () => {
          await this.submitForm();
        },
        reject: () => {
          this.$delete(task, "proceed_action");
          this.$toast.add({
            severity: "warn",
            summary: "Cancelado!",
            detail: "Registo de tarefa cancelado",
            life: 3000,
          });
        },
      });
    },
    cancel() {
      this.$validator.reset();
      this.dialogVisible = false;
      this.$emit("cancel");
    },
    async fetchPats(search = "") {
      try {
        return await interventionService.queryPats({
          types: this.interventionTypes.map((e) => e.id),
          search: search,
        });
      } catch (error) {
        console.error("Error fetching PATs:", error);
        throw error;
      }
    },
    async fetchPatsByIds(ids) {
      try {
        return ids
          .map(id => this.preSelectedPats.find(p => p.patNumber === id) || null)
          .filter(Boolean);
      } catch (error) {
        console.error("Error fetching PATs by IDs:", error);
        throw error;
      }
    },
    getPatLabel(info) {
      if (!info) return "";
      let prefix = info.typeId === 4 ? "Issue" : "PAT";
      let title = info.patTitle || "";
      if (title.length > 15) {
        title = title.slice(0, 15) + "...";
      }
      return `${prefix} ${info.patNumber} - ${title}`;
    },
    getUserSearchLabel(info) {
      return `${info.username}`;
    },
  },
};
</script>
